import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=4f99d470&"
import script from "./Undo.vue?vue&type=script&setup=true&lang=js&"
export * from "./Undo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports